import React from 'react'
import formatNumber from '@arsenal/arsenal/modules/formatNumber'
const live_black_gif = require('static/live-black.gif')

interface IProps {
  viewCount: number
  wrapClassName?: string
}

const LiveBox: React.FC<IProps> = ({ viewCount = 0, wrapClassName = '' }) => {
  return (
    <div className={`live-box ${wrapClassName}`}>
      <span className="live-box-left online">直播中</span>
      <span className="live-box-right">{formatNumber(viewCount)}人次</span>
      <style jsx>
        {`
          .live-box {
            display: flex;
            position: absolute;
            height: 24px;
            z-index: 1;
            top: 8px;
            left: 8px;
          }
          .live-box-left {
            display: flex;
            align-items: center;
            padding: 4px 8px;
            height: 24px;
            border-radius: 2px 0 0 2px;
            background-color: #ffcc32;
            font-size: 10px;
            font-weight: 500;
            line-height: 1.33;
            color: #1f2129;
            vertrial-align: middle;
          }
          .live-box-left.online::before {
            display: block;
            vertical-align: middle;
            content: '';
            width: 14px;
            height: 14px;
            background: url(${require('static/live-black.gif')}) no-repeat
              center;
            background-size: cover;
          }
          .live-box-right {
            position: relative;
            display: block;
            padding: 4px 8px;
            height: 24px;
            border-radius: 0 2px 2px 0;
            font-family: PingFangSC;
            font-size: 10px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #ffffff;
            background: rgba(0, 0, 0, 0.8);
          }
          .live-box-right > span {
            position: relative;
          }
        `}
      </style>
    </div>
  )
}

export default LiveBox
